import { render } from "./HotTrend.vue?vue&type=template&id=0ba62d3d"
import script from "./HotTrend.vue?vue&type=script&lang=js"
export * from "./HotTrend.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__